import { createContext } from "react";

import type useDepartmentIdentityById from "src/hooks/data/load/useDepartmentIdentityById";

/**
 * Describes the department identity loader state and its refresh/cache actions.
 */
export interface IDepartmentIdentityContext extends ReturnType<typeof useDepartmentIdentityById> {}

/**
 * Shares department identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export const DepartmentIdentityContext = createContext<IDepartmentIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default DepartmentIdentityContext;
